import { render, staticRenderFns } from "./Bannerinner.vue?vue&type=template&id=a20e4120&scoped=true&"
import script from "./Bannerinner.vue?vue&type=script&lang=js&"
export * from "./Bannerinner.vue?vue&type=script&lang=js&"
import style0 from "./Bannerinner.vue?vue&type=style&index=0&id=a20e4120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20e4120",
  null
  
)

export default component.exports